import CardInfo from './CardInfo';
import { CardInfoProps, CardInfoValueProps } from './types';

export type { CardInfoProps, CardInfoValueProps };
export default CardInfo;
